import {MetaTitleDesc} from "./../meta";
import DocumentMeta from "react-document-meta";

export default () => {
    const title = 'Брестская область в Европе';

    return (
        <>
            <DocumentMeta {...MetaTitleDesc(title, title)} />

            <div id="content">
                <div className="pageitem">
                    <h2>{title}</h2>

                    <h4>Карты:</h4>
                    <ul>
                        <li>Карта Европы - <a href={require('./../att/Maps/Europe/01.swf')} download>SWF</a></li>
                        <li>Карта Еврорегион "Буг" - <a href={require('./../att/Maps/Europe/02.swf')} download>SWF</a></li>
                    </ul>

                    <p>Важнейшей формой сотрудничества между приграничными регионами стало сотрудничество в рамках Трансграничного объединения «Еврорегион «Буг». Проработка идеи создания Еврорегиона на стыке Беларуси, Украины и Польши велась с 1992 года. Однако трансграничное объединение “Еврорегион «Буг» было образовано лишь в сентябре 1995 года. В его состав на начальном этапе вошли: Волынская область Украины, Люблинское, Хелмское, Тарнобжегское и Замостьское воеводства Республики Польша. Поскольку объединение с момента образования и по сегодняшний день является формированием открытого типа, в мае 1998 года в состав его действительных членов вошли Брестская область Республики Беларусь и Бяло-Подлясское воеводство Республики Польша. После проведенной в Польше административной реформы членами Трансграничного объединения «Еврорегион «Буг» являются Брестская область Республики Беларусь, Люблинское воеводство Республики Польша и Волынская область Украины.</p>
                    <p>In September 1995 an agreement on the creation of Trans-border Union of Bug Euro-region was signed. Besides Wolyn District it included four former provinces of Chelm, Lublin, Tarnobrzeg, and Zamosc. In May 1998 new members were admitted: Brest District Belarus and the former Biala Podlaska province. Since then the Bug Euro-region has been one of the largest in Europe.</p>
                </div>
            </div>
        </>
    );
}